type NormalizedErrorLog = Record<string, unknown>;

export const normalizeErrorForLogs = (error: unknown): NormalizedErrorLog => {
  if (error && typeof error === 'object') {
    const errorResponse = error as any;

    if (errorResponse?.response) {
      return {
        response: { ...errorResponse.response },
        message: typeof errorResponse.message === 'string' ? errorResponse.message : undefined,
        name: typeof errorResponse.name === 'string' ? errorResponse.name : undefined,
      };
    }

    if (typeof errorResponse?.message === 'string') {
      return {
        message: errorResponse.message,
        name: typeof errorResponse.name === 'string' ? errorResponse.name : undefined,
        stack: typeof errorResponse.stack === 'string' ? errorResponse.stack : undefined,
        ...(typeof errorResponse.status_code === 'string' ? { status_code: errorResponse.status_code } : null),
      };
    }

    try {
      return { ...errorResponse };
    } catch {
      return { type: 'non-spreadable-object' };
    }
  }

  return { value: error };
};
